import { ReportKpiTileSeverity } from '../Types/report-kpi-tile-severity.type';

export const TILE_SEVERITY: Record<string, ReportKpiTileSeverity> = {
  notEncrypted: 'error',
  noncompliant: 'error',
  appFailure: 'error',
  noAutopilotHash: 'warning',
  disabledUsers: 'warning',
  inactiveDevices: 'info',
  multipleUsers: 'info',
};
